

		


	<acc-main-login *ngIf="org && action == 'login'" (onNavigateTo)="navigateTo($event)" (onLogin)="login($user)"></acc-main-login>
	<acc-main-recover-password *ngIf="org && action == 'recover-password'" (onNavigateTo)="navigateTo($event)" (onRecover)="recover($event)"></acc-main-recover-password>
	<acc-main-reset-password *ngIf="action == 'reset-password'" (onNavigateTo)="navigateTo($event)" (onReset)="reset($event)"></acc-main-reset-password>
